module.exports = "/assets/career/team/monika.png?Y/0pBxZ";